const INITIAL_STATE = {
  data: {},
  errors: {},
    
}
const lockService = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case 'LOCK_SERVICE_SUCCESSFULLY':
    return { ...INITIAL_STATE, data: action.data }
  case 'LOCK_SERVICE_FAILED':
    return { ...INITIAL_STATE, errors: action.data }
  default:
    return { ...state }
  }
};
    
export default lockService;